import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 24C4 12.954 12.953 4 24 4s20 8.953 20 20-8.953 20-20 20C12.954 44 4 35.047 4 24m2 0c0 9.943 8.058 18 18 18s18-8.058 18-18S33.942 6 24 6 6 14.058 6 24m14.33-9.725a1 1 0 0 0-.002 1.414l7.217 7.236a1.5 1.5 0 0 1-.001 2.12l-7.234 7.23a1 1 0 1 0 1.414 1.416l7.233-7.23a3.5 3.5 0 0 0 .004-4.948l-7.216-7.236a1 1 0 0 0-1.415-.002",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Circled-Right-Outlined_svg__a",
      width: 40,
      height: 40,
      x: 4,
      y: 4,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M4 24C4 12.954 12.953 4 24 4s20 8.953 20 20-8.953 20-20 20C12.954 44 4 35.047 4 24m2 0c0 9.943 8.058 18 18 18s18-8.058 18-18S33.942 6 24 6 6 14.058 6 24m14.33-9.725a1 1 0 0 0-.002 1.414l7.217 7.236a1.5 1.5 0 0 1-.001 2.12l-7.234 7.23a1 1 0 1 0 1.414 1.416l7.233-7.23a3.5 3.5 0 0 0 .004-4.948l-7.216-7.236a1 1 0 0 0-1.415-.002",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Circled-Right-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgCircledRightOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledRightOutlined_default = SvgCircledRightOutlined;

export { CircledRightOutlined_default as default };
